export default {
  get () {
    return [
      {
        name: 'Education',
        contents: [
          {
            texts: [
              'HDK, University for Design and Crafts, Master in fine arts in ceramic art, Göteborg 1998-2004',
              'Kyrkeruds folk school, Art & form program, Ârjäng 1996-1998'
            ]
          }
        ]
      },
      {
        name: 'Exhibitions',
        contents: [
          {
            headline: 'Solo',
            texts: [
              'Arvika Konsthantverk, Arvika, 2010',
              'Formargruppen, Malmö, 2009',
              'Galleri ReForma, Karlstad 2008',
              'Skånekraft, Lund, 2008',
              'Lerverk, Galleri Down Under, Göteborg, 2006',
              'Lerverk “...and they all got lost in the sunset” Göteborg 2005'
            ]
          },
          {
            headline: 'Joint',
            texts: [
              'Röhsska Museet Konstslöjdsalong, Göteborg 2009',
              'Galleri Cancan, Danmark 2007',
              'Galleri Lerverk, “vacker tass” Göteborg 2006',
              '100 tankar om konsthantverk, jury judged. Touring exhibition, Sweden 2005-2008',
              'Virsbo Art gallery, Virsbo 2005',
              'Konsthantverkarna, Örebro 2004',
              'Racksta museet,“keramisk samtidsdialog”, Arvika 2004',
              'Galleri Hantverket, Stockholm 2004',
              'Röhsska museet, Göteborg 2004',
              'Stockholm artfair, Sollentuna mässan 2003',
              'Konstepidemin, Göteborg 2001',
              'Lerverk, “Claygirls”, Göteborg 2001',
              'Röda Sten, “Lera på Röda Sten“, Göteborg 1999'
            ]
          }
        ]
      },
      {
        name: 'Project & Workshops',
        contents: [
          {
            texts: [
              'Helge Ax:son Johnsons Stiftelse, 2006',
              'August Ringnér Stipendiefond,2006',
              'Sweden-Japan Foundation, 2006',
              'Wilhelm & Martina Lundgrens Understödsfond, 2006, 2005',
              'Otto & Charlotte Mannheimers fond, 2005, 2004 ',
              'Estrid Ericssons stiftelse 2006, 2005, 2004, 2003 ',
              'Fabrikör J L Eklunds hantverksstiftelse 2004, 2003',
              'Fredrika Bremer förbundets stipendiestiften/Petersenska hemmet, 2003'
            ]
          }
        ]
      },
      {
        name: 'Scholarships',
        contents: [
          {
            texts: [
              'Office Hours, Made By, Stockholm 2008',
              'Nordic Network Studio Exchange Program, Hirshals, Danmark 2007',
              'Artist in residence, Shigaraki Ceramic Center, Shigaraki, Japan 2006'
            ]
          }
        ]
      },
      {
        name: 'Other',
        contents: [
          {
            texts: [
              'The Arvika Music Festival, Stage design, (an Group assignment) Arvika 1998'
            ]
          }
        ]
      },
      {
        name: 'Download CV',
        contents: [
          {
            downloadLink: 'cv.pdf'
          }
        ]
      }
    ]
  }
}
